import { CompactButton } from '@/components/buttons';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CustomContentSection } from '@/components/custom-content-section';
import { useShoppingCart } from '@/contexts';
import { PrimaryLayout } from '@/layouts/primary';
import { BackgroundImage, CheckIcon, Flex, Image, Text } from '@mantine/core';
import { IconHelpCircle } from '@tabler/icons-react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useCallback, useEffect, useMemo } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import backgroundImage from './background-image.svg';
import mascotImage from './mascot-image.svg';

export const CheckoutResultPage = () => {
	const navigate = useNavigate();
	const { clearCart } = useShoppingCart();
	const { sessionId } = useParams({ from: '/_app/checkout-product-result/$sessionId' });

	/** Clear Shopping Cart */
	useEffect(() => {
		clearCart();
	}, [clearCart, sessionId]);

	const backToHome = useCallback(() => navigate({ to: '/home' }), [navigate]);
	const backToHomeButton = useMemo(
		() => <StandardButton onClick={backToHome}>Back to Home</StandardButton>,
		[backToHome]
	);

	const goToHelp = useCallback(() => navigate({ to: '/help' }), [navigate]);
	const helpButton = useMemo(
		() => (
			<CompactButton leftSection={<IconHelpCircle />} onClick={goToHelp}>
				Help
			</CompactButton>
		),
		[goToHelp]
	);

	return (
		<PrimaryLayout
			header={{ backTo: '/shop', title: 'Checkout', children: helpButton }}
			footer={{ children: backToHomeButton }}
		>
			<BackgroundImage src={backgroundImage} h="100vh">
				<ContentPanel>
					<CustomContentSection
						location={ContentSectionLocation.CheckoutProductResult}
						placement={ContentSectionPlacement.Top}
					/>
					<Flex direction="column" gap={50} align="center" mt={50}>
						<Image src={mascotImage} alt="Mascot" style={{ width: 200 }} />
						<Text ta="center" size="lg" fw={900} flex={1}>
							<CheckIcon size={17} color="green" /> Your payment was successful! Thank you for your
							purchase.
						</Text>
					</Flex>
					<CustomContentSection
						location={ContentSectionLocation.CheckoutProductResult}
						placement={ContentSectionPlacement.Middle}
					/>
					<CustomContentSection
						location={ContentSectionLocation.CheckoutProductResult}
						placement={ContentSectionPlacement.Bottom}
					/>
				</ContentPanel>
			</BackgroundImage>
		</PrimaryLayout>
	);
};
